"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
  _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
  _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
  _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
  _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
  _react = _interopRequireWildcard(require("react")),
  _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    (0, _defineProperty2["default"])(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
var _default = function _default(a) {
  var b = a.field,
    c = a.value,
    d = a.validationMessage,
    e = a.touched,
    f = a.setTouched,
    g = a.hideField,
    h = a.updateForm,
    i = a.styledComponents,
    j = a.error,
    k = a.unsetError,
    l = a.setFocusClass,
    m = a.cssClass,
    n = (0, _objectWithoutProperties2["default"])(a, ["field", "value", "validationMessage", "touched", "setTouched", "hideField", "updateForm", "styledComponents", "error", "unsetError", "setFocusClass", "cssClass"]),
    o = b.id,
    p = b.formId,
    q = b.type,
    r = b.label,
    s = b.placeholder,
    t = b.isRequired,
    u = b.maxLength,
    v = b.description,
    w = b.descriptionPlacement,
    x = b.labelPlacement,
    y = b.width,
    z = b.inputs,
    A = b.customName,
    B = b.dateType,
    C = b.dateFormat,
    D = b.defaultValue,
    E = b.datepickerOptions,
    F = i || !1,
    G = F.Input,
    H = void 0 === G ? "input" : G,
    I = F.Label,
    J = void 0 === I ? "label" : I,
    K = F.Box,
    L = void 0 === K ? "div" : K,
    M = F.DatePicker,
    N = void 0 === M ? "div" : M,
    O = F.ReactSelect,
    P = O || Select,
    Q = !!(C && "dmy" === C) && "dd/MM/yyyy",
    R = !!D && new Date(D);
  if (Q && D) {
    var S = -1 < D.indexOf("/"),
      T = S ? D.split("/") : D.split("-"),
      U = S ? new Date(+T[2], T[1] - 1, +T[0]) : T;
    R = U;
  }
  var V = (0, _react.useState)(R),
    W = (0, _slicedToArray2["default"])(V, 2),
    X = W[0],
    Y = W[1],
    Z = function getFormattedInputs(a) {
      if (B) {
        if ("datefield" === B) return "dmy" === C || "dmy_dash" === C || "dmy_dot" === C ? [a[1], a[0], a[2]] : "ymd_slash" === C || "ymd_dash" === C || "ymd_dot" === C ? [a[2], a[0], a[1]] : a;
        if ("datedropdown" === B) return [a[1], a[0], a[2]];
      }
      return a;
    }(z),
    $ = function adjustDatePickerOptions(a) {
      if (B && "datepicker" === B && a) {
        var b = Object.keys(a);
        if (b && 0 < b.length) for (var c = 0; c < b.length; c++) ("minDate" === b[c] || "maxDate" === b[c]) && (a[b[c]] = new Date(a[b[c]]));
      }
      return a;
    }(E) || {},
    _ = function _(a, b, c) {
      for (var d = [], e = b < c ? 1 : -1, f = b; f != c + e; f += e) d.push({
        value: f,
        label: f,
        selected: parseInt(f) === parseInt(a)
      });
      return d;
    },
    aa = function aa(a, b, c) {
      var d = X || [],
        e = 0 === c ? 2 : 2 === c ? 0 : 1;
      d[e] = a.value, Y(d);
      var f = {
        target: {
          value: a.value
        }
      };
      h(f, b);
    },
    ba = function ba(a) {
      if (X) {
        var b = 0 === a ? 2 : 1 === a ? 1 : 0;
        return X[b] ? {
          value: X[b],
          label: X[b]
        } : void 0;
      }
    };
  return _react["default"].createElement(L, {
    width: y,
    className: d && e || j ? "form-field error ".concat(m) : "form-field ".concat(m),
    style: {
      display: g ? "none" : void 0
    }
  }, _react["default"].createElement(J, {
    htmlFor: "input_".concat(p, "_").concat(o),
    className: "gf-label ".concat(x)
  }, r, t ? _react["default"].createElement("abbr", null, "*") : null), _react["default"].createElement("div", {
    className: q
  }, "above" === w && v && _react["default"].createElement("div", {
    className: "description"
  }, v), B && "datefield" !== B ? "datepicker" === B ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(N, {
    className: "ginput_container ginput_container_date"
  }, _react["default"].createElement(_reactDatepicker["default"], (0, _extends2["default"])({
    name: "input_".concat(o),
    id: "input_".concat(p, "_").concat(o),
    type: "text",
    className: "datepicker hasDatepicker",
    selected: X,
    onChange: function onChange(a) {
      Y(a), h({
        target: {
          value: a
        }
      }, b), f(o), k(o), l(a);
    },
    onBlur: function onBlur() {
      h({
        target: {
          value: X
        }
      }, b), f(o), k(o), l(X);
    },
    dateFormat: Q || void 0,
    onFocus: function onFocus() {
      return l(!0);
    },
    autoComplete: "off",
    required: t,
    placeholderText: s,
    maxDate: m.includes("past") && new Date()
  }, $))), (d && e || j) && _react["default"].createElement("span", {
    className: "error-message",
    id: "error_".concat(p, "_").concat(o)
  }, d || j)) : _react["default"].createElement(_react["default"].Fragment, null, Z && Z.map(function (a, c) {
    return _react["default"].createElement("div", {
      key: a.id,
      className: "gfield_date_dropdown"
    }, _react["default"].createElement(P, {
      required: t,
      placeholder: a.placeholder,
      options: 0 === c ? _(1, 1, 31) : 1 === c ? _(3, 1, 12) : _(0, 1920, new Date().getFullYear()),
      value: ba(c),
      id: "input_".concat(p, "_").concat(o, "_").concat(c + 1),
      name: A || "input_".concat(o, "[]"),
      onBlur: function onBlur() {
        var d = ba(c);
        if (!d) {
          var e = _objectSpread(_objectSpread({}, b), {}, {
            subId: c,
            dateLabel: a.label
          });
          aa({
            value: ""
          }, e, c);
        }
        f(o), k(o), l("" !== a.value);
      },
      onChange: function onChange(d) {
        var e = _objectSpread(_objectSpread({}, b), {}, {
          subId: c,
          dateLabel: a.label
        });
        aa(d, e, c), k(o);
      },
      onFocus: function onFocus() {
        return l(!0);
      }
    }));
  }), (d && e || j) && _react["default"].createElement("span", {
    className: "error-message",
    id: "error_".concat(p, "_").concat(o)
  }, d || j)) : _react["default"].createElement(_react["default"].Fragment, null, Z && Z.map(function (a, c) {
    return _react["default"].createElement("div", {
      className: q,
      key: a.id
    }, _react["default"].createElement(H, {
      id: "input_".concat(p, "_").concat(o, "_").concat(c),
      type: "number",
      name: A || "input_".concat(o, "[]"),
      placeholder: a.placeholder,
      step: "1",
      min: "1",
      max: "MM" === a.label ? 12 : "DD" === a.label ? 31 : new Date().getFullYear() + 1,
      maxLength: "YYYY" === a.label ? 4 : 2,
      value: a.value,
      onBlur: function onBlur(d) {
        b.subId = c, b.dateLabel = a.label, h(d, b), f(o), k(o), l("" !== a.value);
      },
      onFocus: function onFocus() {
        return l(!0);
      }
    }), _react["default"].createElement("label", {
      htmlFor: "input_".concat(p, "_").concat(o, "_").concat(c),
      className: "hide-label"
    }, a.label), d && e && d[c] && c === d[c].index && d[c].message && _react["default"].createElement("span", {
      className: "error-message",
      id: "error_".concat(p, "_").concat(a.id)
    }, d[c].message), j && _react["default"].createElement("span", {
      className: "error-message"
    }, j));
  })), "above" !== w && v && _react["default"].createElement("div", {
    className: "description"
  }, v)));
};
exports["default"] = _default;